import angular from 'angular'
import inputInvoicePool from './inputInvoicePool'

export default angular.module('input.invoicePool', [inputInvoicePool]).config([
    '$stateProvider',
    ($stateProvider) => {
        $stateProvider.state('input.invoicePool', {
            url: '/ivat',
            template: '<div ui-view></div>',
            abstract: true,
            title: '发票池',
        })
    },
]).name



// WEBPACK FOOTER //
// ./src/app/input/invoicePool/index.js